import { useFormContext } from "react-hook-form";
import { FormControl, FormField, FormItem, FormMessage } from "@shadcn/components/ui/form";
import { Input } from "@shadcn/components/ui/input";
import { Content } from "@forms/form-render/components/Fields/Content";
import { VonageVerifyEmailEntryProps } from "./VonageVerifyEmailEntry.types";
import { Mail } from "lucide-react";
import { AlertVariant, ContentFieldConfig } from "@schema-types/types/JourneySchema";

const emailInfoConfig: ContentFieldConfig = {
  alertVariant: AlertVariant.Warning,
  icon: "AlertTriangle",
  content:
    "Important! We will send a verification code to this email address and ask you to enter it on a later step before you can continue.",
};

export const VonageVerifyEmailEntry = ({ required, disabled, showInfoMessage = true }: VonageVerifyEmailEntryProps) => {
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name="email_address"
      rules={{
        required: required ? "Email is required" : false,
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Please enter a valid email address",
        },
      }}
      render={({ field }) => (
        <FormItem>
          {showInfoMessage ? (
            <div className="mb-2">
              <Content config={emailInfoConfig} />
            </div>
          ) : null}
          <FormMessage />
          <FormControl>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground pointer-events-none" />
              <Input
                {...field}
                id="email_address"
                type="email"
                placeholder="Enter your email address..."
                disabled={disabled}
                className="pl-9"
              />
            </div>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
